import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { getTeamOnLeaveAPI } from '../../../../Redux/Apis/dashboard';
import Loader from '../../../atoms/Loader/Loader';

const getInitials = (first = '', last = '') => {
    const a = String(first).trim().charAt(0);
    const b = String(last).trim().charAt(0);
    return (a + b).toUpperCase() || '?';
};

const getLeaveDisplayLabel = (leaveType) => {
    const t = String(leaveType || '').trim();
    if (t === 'Multiple Days Leave') return 'On leave';
    return t || 'On leave';
};

const getLeaveBadgeClass = (leaveType) => {
    const t = String(leaveType || '').trim();
    if (t === 'WFH' || t.toLowerCase() === 'work from home') return 'dashboard-leave-badge dashboard-leave-badge--teal';
    if (t === 'Early Leave') return 'dashboard-leave-badge dashboard-leave-badge--amber';
    if (t === 'Half Leave') return 'dashboard-leave-badge dashboard-leave-badge--violet';
    if (t === 'Full Leave' || t === 'Multiple Days Leave') return 'dashboard-leave-badge dashboard-leave-badge--sky';
    return 'dashboard-leave-badge dashboard-leave-badge--slate';
};

const AVATAR_CLASSES = [
    'dashboard-widget-avatar',
    'dashboard-widget-avatar dashboard-widget-avatar--rose',
    'dashboard-widget-avatar dashboard-widget-avatar--amber',
    'dashboard-widget-avatar dashboard-widget-avatar--violet',
    'dashboard-widget-avatar dashboard-widget-avatar--teal',
];

const EmployeeLeave = () => {
    const dispatch = useDispatch();
    const { allPendingLeaves, loading } = useSelector(state => state.dashboard);

    useEffect(() => {
        dispatch(getTeamOnLeaveAPI({ date: moment().format('YYYY-MM-DD') }));
    }, [dispatch]);

    const count = allPendingLeaves?.length ?? 0;

    return (
        <div className="dashboard-widget dashboard-widget--leave">
            <div className="dashboard-widget-header">
                <div className="dashboard-widget-header-left">
                    <span className="dashboard-widget-icon-wrap">
                        <img src="/svg/Icons/leave-icon.svg" alt="" aria-hidden="true" />
                    </span>
                    <h4 className="dashboard-widget-title">Employee On Leave</h4>
                </div>
                <span className="dashboard-widget-count">{count}</span>
            </div>
            <div className="dashboard-widget-body">
                {loading ? (
                    <div className="dashboard-widget-empty">
                        <Loader />
                    </div>
                ) : count === 0 ? (
                    <div className="dashboard-widget-empty">
                        <span className="dashboard-widget-empty-icon dashboard-widget-empty-icon--leave" aria-hidden="true">
                            ✓
                        </span>
                        <p className="dashboard-widget-empty-text">Everyone is present today</p>
                        <p className="dashboard-widget-empty-hint">No team members on leave right now</p>
                    </div>
                ) : (
                    <ul className="dashboard-widget-list">
                        {allPendingLeaves.map((leave, index) => (
                            <li key={leave.leaveRequestId} className="dashboard-widget-list-item">
                                <span className={AVATAR_CLASSES[index % AVATAR_CLASSES.length]}>
                                    {getInitials(leave.userFirstname, leave.userLastname)}
                                </span>
                                <div className="dashboard-widget-item-main">
                                    <div className="dashboard-widget-item-name">
                                        {leave.userFirstname} {leave.userLastname}
                                    </div>
                                </div>
                                <span className={getLeaveBadgeClass(leave?.leaveType)}>
                                    {getLeaveDisplayLabel(leave?.leaveType)}
                                </span>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
};

export default EmployeeLeave;
